<template>
  <div>
    <div class="banner_box">
      <img src="../assets/images/banner-500/contactus.jpg">
    </div>
    <div class="body-width divcss5">
      <contactcontent></contactcontent>
    </div>
  </div>
</template>

<script>
    import contactcontent from "@/components/contentcoms/contactcontentcoms/contactcontent";
    import banner from "@/components/commoncoms/banner";
    export default {
      name: "contact",
      components: {contactcontent,banner}
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/contact.vue